import React from 'react'
import { useEffect, useState, useContext } from 'react'
import { toast } from 'react-toastify'
import TableHeader from '../components/TableHeader'
import TypeTable from '../components/TypeTable'
import Loader from './../components/Loader'
import { getLocales } from './../services/Locale/index'
import { Container } from 'react-bootstrap'
import DataContext from '../store/data-context'

function NewType() {
    const { setLocales, type } = useContext(DataContext)
    const [isLoaded, setIsLoaded] = useState(false)

    useEffect(() => {
        setIsLoaded(false)
        const fetchLocales = async () => {
            const resp = await getLocales()
            if (resp.success)
                setLocales(resp.data.map(item => ({ value: item.short, label: item.full, isDefault: item.isDefault })))
            else
                throw new Error(resp.error)
        }

        const fetchData = async () => {
            try {
                await fetchLocales()
                setIsLoaded(true)
            } catch (error) {
                toast.error('Error while fetching data. Reloading the page', {
                    onClose: () => window.location.reload(),
                    pauseOnHover: false
                })
            }
        }

        fetchData()
    }, [setLocales])

    return (
        <Container>
            <h2 className='text-center'>mwanAPI Data Insertion</h2>
            {isLoaded
                ? (<>
                    <Container>
                        <TableHeader />
                    </Container>
                    {type.value.length ? < TypeTable /> : <></>}
                </>)
                : <Loader />
            }
        </Container >
    )
}

export default NewType